var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ListItemButton } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
var ActionField = function (_a) {
    var label = _a.label, iconName = _a.iconName, inverted = _a.inverted, disabled = _a.disabled, onClick = _a.onClick;
    return (React.createElement(ListItemButton, __assign({ onClick: onClick, disabled: disabled, className: "actionField", sx: {
            '&:hover': {
                backgroundColor: function (theme) { return inverted ? theme.palette.background.invertedHover : undefined; }
            }
        } }, { 'data-label': label, 'data-icon-name': iconName }),
        iconName && React.createElement(AccurityIcon, { iconName: iconName, className: 'actionField__icon' }),
        React.createElement("div", { className: 'actionField__label' }, label)));
};
export default ActionField;
//# sourceMappingURL=ActionField.js.map